import React from 'react';
import * as yup from 'yup';
import Logo from 'assets/Logo';
import Form from 'components/elements/Form/form';
import Input from 'components/elements/Form/Input/input';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation, useQueryClient } from 'react-query';
import ResetPasswordService from 'services/hooks/reset-password-service';
import PasswordResetMessage from './PasswordResetMessage';
import LoadingSpinner from 'components/elements/Spinner/LoadingSpinner';

interface ForgotPasswordInterface {
  username: string;
}

// validation
const ForgotPasswordSchema = yup.object().shape({
  username: yup.string().required('email is required')
});

function ForgotPassword() {
  const [complete, setComplete] = React.useState(false);
  const [error, setError] = React.useState('');
  const methods = useForm({ resolver: yupResolver(ForgotPasswordSchema) });
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(ResetPasswordService.forgotPasswordConfirm, {
    onSuccess: () => {
      console.log('successfully');
      setComplete(true);
    },
    onError: () => {
      console.log('something went wrong');
      setError('Something went wrong. Please try again and contact support if the issue persists.');
    },
    onSettled: () => {
      queryClient.invalidateQueries('create');
    }
  });
  const onSubmit = async (data: ForgotPasswordInterface) => {
    mutate(data);
  };

  if (!complete) {
    return isLoading ? (
      <LoadingSpinner />
    ) : (
      <div className="flex min-h-screen flex-col justify-center overflow-hidden sm:py-12 publicBackgroundImage">
        <div className="relative bg-primary2 px-6 pt-16 pb-8 w-full shadow-xl sm:mx-auto max-w-[460px] sm:rounded-lg sm:px-10 rounded">
          <div className="absolute top-10 left-1/2 transform -translate-x-1/2 mt-15">
            <Logo />
          </div>
          <div className="mx-auto max-w-md">
            <div className="py-8 text-center leading-7">
              <h3 className="text-3xl font-normal py-5">Forgot Password?</h3>
              <div style={{ marginBottom: '35px' }}>
                {' '}
                Enter your Email to receive recovery Information{' '}
              </div>
              <Form
                buttonLabel="Forgot Password"
                methods={methods}
                onSubmit={onSubmit}
                styles="text-left"
                customStyles={'!pb-8'}
              >
                <Input
                  label="EMAIL ADDRESS"
                  name="username"
                  type="text"
                  data-testid="example"
                  placeholder="sam.smith@bline.io"
                  autoFocus
                  labelClass="!font-normal"
                />
                {error && <div className="flex text-secondary2">{error}</div>}
              </Form>
            </div>
          </div>
          <div className="relative text-center text-neutral5 leading-4 whitespace-nowrap text-sm">
            ©2024 B-Line Technologies Inc. All rights reserved.
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex min-h-screen flex-col justify-center overflow-hidden sm:py-12 publicBackgroundImage">
        <div className="relative bg-primary2 px-6 pt-16 pb-8 w-full shadow-xl sm:mx-auto max-w-[460px] sm:rounded-2xl sm:px-10 rounded">
          <div className="absolute top-10 left-1/2 transform -translate-x-1/2 mt-15">
            <Logo />
          </div>
          <div className="mx-auto max-w-md">
            <div className="py-8 text-center leading-7">
              <h3 className="text-3xl font-normal py-5 text-center">Forgot Password?</h3>
              <PasswordResetMessage message="Check your email for password reset instructions." />
            </div>
            <div className="relative text-center text-neutral5 leading-4 whitespace-nowrap text-sm">
              ©2024 B-Line Technologies Inc. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
